module.exports = __webpack_public_path__ + "static/img/sou-q-m@2x.628d07e7.png";